/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { TrashedPlans } from '@jira/spa-apps__admin-pages-trashed-plans/src/TrashedPlans.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyTrashedPlans: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof TrashedPlans
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-trashed-plans", jiraSpaEntry: "async-trashed-plans" */ '@jira/spa-apps__admin-pages-trashed-plans/src/TrashedPlans.tsx'
		).then((module) => module.TrashedPlans),
	),
);

export const TrashedPlansDirectory = (): React.JSX.Element => (
	<LazyPage Page={LazyTrashedPlans} pageId="trashed-plans" shouldShowSpinner />
);
